export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/directory-manage.controller.js